import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCloseButton from 'components/common/FalconCloseButton';
import SoftBadge from 'components/common/SoftBadge';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useEffect, useState } from 'react';

import circle from 'assets/img/icons/connect-circle.png';
import corner2 from 'assets/img/illustrations/corner-5.png';
import Background from 'components/common/Background';
import { Alert, Badge, Button, Card, CloseButton, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import ModalClienteGanado from './ModalClienteGanado';
import ModalSeguimientoLead from './ModalSeguimientoLead';

// Componentes modulares
import ContactosHeader from './components/ContactosHeader';
import FiltrosContactos from './components/FiltrosContactos';
import FormularioRegistroLead from './components/FormularioRegistroLead';
import LeadsLiberados from './components/LeadsLiberados';
import ProximosEventos from './components/ProximosEventos';

// Hook personalizado
import useContactosAPI from './hooks/useContactosAPI';

// Estilos personalizados
import styles from './Contacts.module.css';

const Contacts = () => {
    // Hook personalizado para API
    const {
        obtenerCatalogoLeads,
        guardarLead,
        verificarLeadRepetido,
        cambiarEtapaLead,
        obtenerEventosPorVendedor,
        obtenerLeadsLiberados,
        registrarComentario,
        guardarNotificacion,
        idUsuario,
        nombreCompleto
    } = useContactosAPI();

    // Estados principales
    const [cargando, setCargando] = useState(true);
    const [contactos, setContactos] = useState([]);
    // const [vendedores, setVendedores] = useState([]);
    const [catEtapas, setCatEtapas] = useState([]);
    const [tags, setTags] = useState([]);

    // Estados de filtros
    const [ordenarPor, setOrdenarPor] = useState(0);
    const [vendedor, setVendedor] = useState(0);
    const [idSource_, setidSource_] = useState(0);
    const [etapa, setEtapa] = useState(0);
    const [Filter_Tags, setFilter_Tags] = useState([]);
    const [Filter_NumTelNameLead, setFilter_NumTelNameLead] = useState('');
    const [filtroEventos, setFiltroEventos] = useState(false);
    const [filtroEventosVencidos, setFiltroEventosVencidos] = useState(false);

    // Estados de eventos
    const [proximoEvento, setProximoEvento] = useState([]);
    const [listaEventos, setListaEventos] = useState([]);
    const [listaEventosPasados, setListaEventosPasados] = useState([]);
    const [listaEventosHoy, setListaEventosHoy] = useState([]);
    const [listaEventosFuturos, setListaEventosFuturos] = useState([]);

    // Estados de leads liberados
    const [lista3LeadsLiberados, setLista3LeadsLiberados] = useState([]);
    const [listaLeadsLiberados, setListaLeadsLiberados] = useState([]);

    // Estados de modales
    const [showModal, setShowModal] = useState(false);
    const [showModalSimilarLeads, setshowModalSimilarLeads] = useState(false);
    const [showModalEventosNoTerminados, setShowModalEventosNoTerminados] = useState(true);
    const [showModalLeadsLiberados, setShowModalLeadsLiberados] = useState(false);
    const [showEtapaNoInteresadoModal, setShowEtapaNoInteresadoModal] = useState(false);
    const [showEtapaClienteGanadoModal, setShowEtapaClienteGanadoModal] = useState(false);

    // Estados auxiliares
    const [editarEtapa, setEditarEtapa] = useState("");
    const [motivoNoInteresado, setMotivoNoInteresado] = useState('');
    const [vNombreEtapa, setvNombreEtapa] = useState(null);
    const [idLead, setIdLead] = useState(0);
    const [esExactamenteIgual, setEsExactamenteIgual] = useState(false);
    const [procesandoModalSimilarLeads, setProcesandoModalSimilarLeads] = useState(false);
    const [dataRepeatedLeads, setDataRepeatedLeads] = useState([]);
    const [telefonoRegistrar, setTelefonoRegistrar] = useState("");
    const [cargandoModalEventos, setCargandoModalEventos] = useState(true);
    const [cargandoModalLeads, setCargandoModalLeads] = useState(false);
    const [habilitarBtnGuardar, setHabilitarBtnGuardar] = useState(true);
    const [listaJsonLeadsVinculados, setListaJsonLeadsVinculados] = useState([]);

    useEffect(() => {
        mostrarLeads(Filter_Tags, filtroEventosVencidos);

        if (showModalEventosNoTerminados) {
            eventosNoTerminados();
        }
    }, [vendedor, idSource_, etapa, ordenarPor, filtroEventos]);

    /**
     * Obtiene y muestra los leads con filtros aplicados
     */
    const mostrarLeads = async (_filterTags, _bFiltroEventosVencidos) => {
        setCargando(true);

        const idVendedor_ = sessionStorage.getItem("selectIDUsuario") == null
            ? (vendedor == 0) ? idUsuario : vendedor
            : parseInt(sessionStorage.getItem("selectIDUsuario"), 10) || 0;
        setVendedor(idVendedor_);

        const filtros = {
            idVendedor: idVendedor_,
            idSource: idSource_,
            idEtapa: etapa,
            jsonTags: _filterTags,
            vNumNameLead: Filter_NumTelNameLead,
            bFiltroEventos: filtroEventos,
            iOrdenarPor: ordenarPor,
            bFiltroEventosVencidos: _bFiltroEventosVencidos
        };

    

        const resultado = await obtenerCatalogoLeads(filtros);

        if (resultado) {
            // setVendedores(resultado.vendedores);
            // setCatEtapas(resultado.catEtapas);
            setContactos(resultado.contactos);
            setTags(resultado.tags);
            setProximoEvento(resultado.proximoEvento);
            setListaEventos(resultado.listaEventos);
            setLista3LeadsLiberados(resultado.lista3LeadsLiberados);
        }

        setCargando(false);
    };

    /**
     * Guarda un nuevo lead
     */
    const GuardarLead = async (telefono) => {
        setCargando(true);
        const objLead = await guardarLead(telefono);

        if (objLead) {
            setIdLead(objLead.idLead);
            await registrarComentario(
                objLead.idLead,
                `<b class='badge badge-soft-success'>Lead registrado por ${objLead.vVendedor}</b>`,
                2
            );
            setShowModal(true);
        }

        setCargando(false);
    };

    /**
     * Verifica si el lead ya existe
     */
    const VerificarLeadRepetido = async (data) => {
        setshowModalSimilarLeads(true);
        setProcesandoModalSimilarLeads(true);
        setEsExactamenteIgual(false);

        const resultado = await verificarLeadRepetido(data.vTelefonoLead);

        if (!resultado) {
            setProcesandoModalSimilarLeads(false);
            return;
        }

        if (resultado.iResponseType === 1) {
            await GuardarLead(resultado.vCode);
            setshowModalSimilarLeads(false);
        } else if (resultado.iResponseType === 4) {
            setEsExactamenteIgual(true);
            setDataRepeatedLeads(JSON.parse(resultado.detalles));
            setTelefonoRegistrar(resultado.vCode);
        } else if (resultado.iResponseType === 5) {
            setDataRepeatedLeads(JSON.parse(resultado.detalles));
            setTelefonoRegistrar(resultado.vCode);
        }

        setProcesandoModalSimilarLeads(false);
    };

    /**
     * Maneja el cambio de etapa a "No Interesado"
     */
    const etapaNoInteresado = async (idLead) => {
        if (motivoNoInteresado.length <= 5) {
            return;
        }

        setHabilitarBtnGuardar(false);

        const resultado = await cambiarEtapaLead(idLead, 5);

        if (resultado) {
            await registrarComentario(
                idLead,
                `<b class='badge badge-soft-danger'>Lead no interesado </b> ${motivoNoInteresado}`,
                2
            );

            const currentLeadIndex = contactos.findIndex((lead) => lead.idLead === idLead);
            if (currentLeadIndex !== -1) {
                contactos[currentLeadIndex].iDaysDiff = 0;
                contactos[currentLeadIndex].vNombreEtapa = resultado.vNombreEtapa;
                contactos[currentLeadIndex].idEtapa = resultado.idEtapa;
            }

            setEditarEtapa("");
            setMotivoNoInteresado("");
            setShowEtapaNoInteresadoModal(false);

            if (idUsuario != vendedor) {
                const objToActionString = crearObjAction(1, '', 1, idLead);
                await guardarNotificacion(
                    "Etapa de lead cambiada",
                    `<b>${nombreCompleto}</b> modificó la etapa del lead <b>#${idLead}</b> a: <i>'No intere...'</i>`,
                    vendedor,
                    objToActionString
                );
            }
        }

        setHabilitarBtnGuardar(true);
    };

    /**
     * Obtiene eventos por vendedor
     */
    const eventosNoTerminados = async () => {
        setCargandoModalEventos(true);
        setShowModalEventosNoTerminados(true);

        const idVendedor_ = sessionStorage.getItem("selectIDUsuario") == null
            ? (vendedor == 0) ? idUsuario : vendedor
            : parseInt(sessionStorage.getItem("selectIDUsuario"), 10) || 0;
        setVendedor(idVendedor_);

        const resultado = await obtenerEventosPorVendedor(idVendedor_);
        console.log(resultado);
        if (resultado) {
            setListaEventosPasados(resultado.listaEventosPasados);
            setListaEventosHoy(resultado.listaEventosHoy);
            setListaEventosFuturos(resultado.listaEventosFuturos);
        }

        setCargandoModalEventos(false);
    };

    const getMes = (fecha) => {
        const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
        return meses[new Date(fecha).getMonth()];
    };

    /**
     * Obtiene leads liberados
     */
    const leadsLiberados = async () => {
        setShowModalLeadsLiberados(true);
        setCargandoModalLeads(true);

        const resultado = await obtenerLeadsLiberados();
        setListaLeadsLiberados(resultado);

        setCargandoModalLeads(false);
    };

    /**
     * Maneja el cambio de filtro de eventos del día
     */
    const handleCheckedFiltroEventos = (event) => {
        setFiltroEventos(event.target.checked);
        event.preventDefault();
        event.stopPropagation();
    };

    /**
     * Maneja el cambio de filtro de eventos vencidos
     */
    const handleCheckedFiltroEventosVencidos = (event) => {
        setFiltroEventosVencidos(event.target.checked);
        mostrarLeads(Filter_Tags, event.target.checked);
        event.preventDefault();
        event.stopPropagation();
    };

    /**
     * Crea objeto de acción para notificaciones
     */
    const crearObjAction = (TypeAction, vURL, idModalType, idLead) => {
        const objToAction = {
            TypeAction,
            detalles: {
                vUrl: vURL,
                idModalType,
                data: { idLead }
            }
        };
        return JSON.stringify(objToAction);
    };

    const getFlagIcon = (phone) => {
        if (phone.includes('+52')) return { flag: 'bandera-mexico-48.png', country: 'México' };
        if (phone.includes('+1809') || phone.includes('+1829') || phone.includes('+1849'))
            return { flag: 'bandera-dominican-republic-48.png', country: 'República Dominicana' };
        if (phone.includes('+502')) return { flag: 'bandera-guatemala-48.png', country: 'Guatemala' };
        if (phone.includes('+503')) return { flag: 'bandera-el-salvador-48.png', country: 'El Salvador' };
        if (phone.includes('+504')) return { flag: 'bandera-honduras-48.png', country: 'Honduras' };
        if (phone.includes('+505')) return { flag: 'bandera-nicaragua-48.png', country: 'Nicaragua' };
        if (phone.includes('+506')) return { flag: 'bandera-costa-rica-48.png', country: 'Costa Rica' };
        if (phone.includes('+507')) return { flag: 'bandera-panama-48.png', country: 'Panamá' };
        if (phone.includes('+51')) return { flag: 'bandera-peru-48.png', country: 'Perú' };
        if (phone.includes('+53')) return { flag: 'bandera-cuba-48.png', country: 'Cuba' };
        if (phone.includes('+54')) return { flag: 'bandera-argentina-48.png', country: 'Argentina' };
        if (phone.includes('+56')) return { flag: 'bandera-chile-48.png', country: 'Chile' };
        if (phone.includes('+57')) return { flag: 'bandera-colombia-48.png', country: 'Colombia' };
        if (phone.includes('+58')) return { flag: 'bandera-venezuela-48.png', country: 'Venezuela' };
        if (phone.includes('+591')) return { flag: 'bandera-bolivia-48.png', country: 'Bolivia' };
        if (phone.includes('+593')) return { flag: 'bandera-ecuador-48.png', country: 'Ecuador' };
        if (phone.includes('+595')) return { flag: 'bandera-paraguay-circular-48.png', country: 'Paraguay' };
        if (phone.includes('+598')) return { flag: 'bandera-uruguay-48.png', country: 'Uruguay' };
        if (phone.includes('+1787') || phone.includes('+1939'))
            return { flag: 'bandera-puerto-rico-48.png', country: 'Puerto Rico' };
        return null;
    };

    const getSourceInfo = (idSource) => {
        const sources = {
            1: { name: 'WhatsApp', icon: 'WhatsApp48.png', color: '#25D366' },
            2: { name: 'Messenger', icon: 'Messenger48.png', color: '#0084FF' },
            3: { name: 'Facebook', icon: 'Facebook48.png', color: '#1877F2' },
            4: { name: 'Tawk', icon: 'Tawk48.png', color: '#FFA500' },
            5: { name: 'Correo', icon: 'Correo48.png', color: '#EA4335' },
            6: { name: 'AkasiaBot', icon: 'AkasiaBot48.png', color: '#6C757D' },
            7: { name: 'Distribuidor', icon: 'Distribuidor48.png', color: '#0D6EFD' }
        };
        return sources[idSource] || { name: 'Sin definir', icon: null, color: '#6C757D' };
    };

    // Definición de columnas para la tabla principal
    const columns = [
        {
            accessor: 'name',
            Header: 'Nombre',
            cellProps: { className: 'py-3' },
            Cell: rowData => {
                const { vNombreLead, idLead, vJsonTags } = rowData.row.original;
                const objTag = JSON.parse(vJsonTags);

                return (
                    <div className="d-flex flex-column">
                        <div className="mb-1">
                            <Link
                                to={"#"}
                                onClick={() => { setIdLead(idLead); setShowModal(true); }}
                                className="text-primary fw-medium fs--1 text-decoration-none"
                            >
                                <FontAwesomeIcon icon="id-badge" className="me-2 text-600" size="sm" />
                                Lead #{idLead}
                            </Link>
                        </div>
                        <div className="mb-2">
                            <Link
                                to={"#"}
                                onClick={() => { setIdLead(idLead); setShowModal(true); }}
                                className="text-900 fw-semi-bold fs-0 text-decoration-none d-flex align-items-center"
                            >
                                <FontAwesomeIcon icon="eye" className="me-2 text-primary" size="sm" />
                                {vNombreLead || `Lead #${idLead}`}
                            </Link>
                        </div>
                        {objTag.length > 0 && (
                            <div className="d-flex flex-wrap gap-1">
                                {objTag.map((tag, index) => {
                                    const objDDLTag = tags.find(t => t.idLeadTag == tag.idLeadTag);
                                    return objDDLTag ? (
                                        <OverlayTrigger
                                            key={index}
                                            placement="top"
                                            overlay={<Tooltip><strong>{objDDLTag.vNombreTag}</strong></Tooltip>}
                                        >
                                            <span>
                                                <SoftBadge
                                                    className="fs--2"
                                                    bg={objDDLTag.colorActive}
                                                >
                                                    {objDDLTag.vAbreviacionTag}
                                                </SoftBadge>
                                            </span>
                                        </OverlayTrigger>
                                    ) : null;
                                })}
                            </div>
                        )}
                    </div>
                );
            }
        },
        {
            accessor: 'PE',
            Header: 'P.E.',
            headerProps: { className: 'text-center' },
            cellProps: { className: 'text-center' },
            Cell: rowData => {
                const { dPropuestaEconomica, vMoneda } = rowData.row.original;
                return (
                    <div className="text-center">
                        <span className="fw-semi-bold text-900">{dPropuestaEconomica}</span>
                        <small className="text-600 ms-1">{vMoneda}</small>
                    </div>
                );
            }
        },
        {
            accessor: 'telefono',
            Header: 'Contacto',
            headerProps: { className: 'text-nowrap' },
            cellProps: { className: 'py-3' },
            Cell: rowData => {
                const { vTelefonoLead, vCorreo } = rowData.row.original;
                const flagInfo = getFlagIcon(vTelefonoLead);
                return (
                    <div className="d-flex flex-column gap-2">
                        {/* Teléfono */}
                        <div className="d-flex align-items-center gap-2">
                            {flagInfo && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip><strong>{flagInfo.country}</strong></Tooltip>}
                                >
                                    <img
                                        src={`/img/${flagInfo.flag}`}
                                        width="24"
                                        height="24"
                                        alt={flagInfo.country}
                                        className="rounded-circle"
                                        style={{ objectFit: 'cover' }}
                                    />
                                </OverlayTrigger>
                            )}
                            <a
                                className={`text-700 text-decoration-none d-flex align-items-center gap-2 hover-primary ${styles.hoverPrimary}`}
                                href={`https://wa.me/${vTelefonoLead}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <div
                                    className={`bg-success-soft rounded-circle d-flex align-items-center justify-content-center ${styles.bgSuccessSoft}`}
                                    style={{ width: '28px', height: '28px' }}
                                >
                                    <img
                                        src="/img/whatsapp20.png"
                                        alt="WhatsApp"
                                        width="16"
                                        height="16"
                                    />
                                </div>
                                <span className="fw-medium fs--1">{vTelefonoLead}</span>
                            </a>
                        </div>

                        {/* Email */}
                        {vCorreo && (
                            <div className="d-flex align-items-center gap-2">
                                <div
                                    className={`bg-info-soft rounded-circle d-flex align-items-center justify-content-center ${styles.bgInfoSoft}`}
                                    style={{ width: '28px', height: '28px', minWidth: '28px' }}
                                >
                                    <FontAwesomeIcon
                                        icon="envelope"
                                        className="text-info"
                                        size="sm"
                                    />
                                </div>
                                <a
                                    href={`mailto:${vCorreo}`}
                                    className={`text-600 text-decoration-none text-truncate hover-primary fs--1 ${styles.emailLink} ${styles.textTruncate}`}
                                    style={{ maxWidth: '200px' }}
                                    title={vCorreo}
                                >
                                    {vCorreo}
                                </a>
                            </div>
                        )}
                    </div>
                );
            }
        },
        {
            accessor: 'vGiroComercial',
            Header: 'Giro Comercial',
            headerProps: { className: 'pe-5 white-space-nowrap' },
            cellProps: { className: 'font-sans-serif white-space-nowrap' },
            Cell: rowData => <span>{rowData.row.original.vGiroComercial}</span>
        },
        {
            accessor: 'vNombreUsuario',
            Header: 'Vendedor',
            headerProps: { className: 'text-nowrap' },
            cellProps: { className: 'py-3' },
            Cell: rowData => {
                const { vNombreUsuario, dCreatedDate, iDaysDiff, idLead } = rowData.row.original;
                const objEventoProximo = listaEventos.find(t => t.idLead == idLead);

                return (
                    <div className="d-flex flex-column gap-2">
                        <div className="d-flex align-items-center gap-2">
                            <span className="text-900 fw-semi-bold">{vNombreUsuario}</span>
                        </div>
                        <div className="text-600 fs--1">
                            <FontAwesomeIcon icon="calendar-plus" className="me-1 text-500" size="xs" />
                            {new Date(dCreatedDate).toLocaleDateString('es-mx', {
                                year: 'numeric', month: 'short', day: 'numeric'
                            })}
                        </div>
                        <div>
                            <SoftBadge
                                bg={
                                    iDaysDiff >= 0 && iDaysDiff < 3 ? "success" :
                                        iDaysDiff >= 3 && iDaysDiff < 5 ? "warning" : "danger"
                                }
                                className="fs--2"
                            >
                                <FontAwesomeIcon icon="clock" className="me-1" size="xs" />
                                {iDaysDiff} {iDaysDiff === 1 ? 'día' : 'días'}
                            </SoftBadge>
                        </div>
                        {objEventoProximo && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip>
                                        <div className="text-start">
                                            <strong className="d-block mb-1">{objEventoProximo.vTituloEvento}</strong>
                                            {objEventoProximo.vDescripcionEvento && (
                                                <small className="d-block mb-1">{objEventoProximo.vDescripcionEvento}</small>
                                            )}
                                            <small className="d-block">
                                                {new Date(objEventoProximo.dFechaEvento).toLocaleDateString('es-mx', {
                                                    weekday: 'long', year: 'numeric', month: 'short', day: 'numeric'
                                                })}
                                            </small>
                                            <small className="d-block">
                                                {new Date(objEventoProximo.dFechaEvento).toLocaleTimeString('es-mx', { 
                                                    hour: '2-digit', 
                                                    minute: '2-digit',
                                                    hour12: true 
                                                })}
                                            </small>
                                        </div>
                                    </Tooltip>
                                }
                            >
                                <div className="d-flex align-items-center gap-2">
                                    <div
                                        className="bg-warning-soft rounded-circle d-flex align-items-center justify-content-center"
                                        style={{ width: '24px', height: '24px', minWidth: '24px' }}
                                    >
                                        <FontAwesomeIcon
                                            icon="calendar-check"
                                            className="text-warning"
                                            size="sm"
                                        />
                                    </div>
                                    <div className="text-warning fw-semi-bold fs--2">
                                        Evento programado
                                    </div>
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                );
            }
        },
        {
            accessor: 'etapa',
            Header: 'Etapa',
            headerProps: { className: 'text-end' },
            cellProps: { className: 'text-end py-3' },
            Cell: rowData => {
                const { idEtapa, vNombreEtapa, idLead, vJsonLeadsVinculados, idSource } = rowData.row.original;
                const sourceInfo = getSourceInfo(idSource);

                return editarEtapa == idLead ? (
                    <div className="d-flex align-items-center justify-content-end gap-2">
                        <Form.Select
                            size="sm"
                            value={idEtapa}
                            className="w-auto"
                            onChange={async (event) => {
                                const currentLeadIndex = contactos.findIndex((lead) => lead.idLead === idLead);

                                if (event.target.value == 5) {
                                    setIdLead(idLead);
                                    setShowEtapaNoInteresadoModal(true);
                                    setHabilitarBtnGuardar(true);
                                } else if (event.target.value == 4 && contactos[currentLeadIndex].idClienteAkasia == null) {
                                    setvNombreEtapa(vNombreEtapa);
                                    setIdLead(idLead);

                                    const leadsVinculados = JSON.parse(vJsonLeadsVinculados);
                                    if (leadsVinculados != null) {
                                        const newArray = leadsVinculados.filter(l => l.idLead !== idLead);
                                        setListaJsonLeadsVinculados(newArray);
                                    }

                                    setShowEtapaClienteGanadoModal(true);
                                } else {
                                    const resultado = await cambiarEtapaLead(idLead, event.target.value);

                                    if (resultado) {
                                        await registrarComentario(
                                            idLead,
                                            `Modificó etapa de <b>${contactos[currentLeadIndex].vNombreEtapa}</b> a <b>${resultado.vNombreEtapa}</b>`,
                                            2
                                        );

                                        contactos[currentLeadIndex].idEtapa = resultado.idEtapa;
                                        contactos[currentLeadIndex].vNombreEtapa = resultado.vNombreEtapa;
                                        contactos[currentLeadIndex].iDaysDiff = 0;

                                        setEditarEtapa("");

                                        if (idUsuario != vendedor) {
                                            const objToActionString = crearObjAction(1, '', 1, idLead);
                                            await guardarNotificacion(
                                                "Etapa de lead cambiada",
                                                `<b>${nombreCompleto}</b> modificó la etapa del lead <b>#${idLead}</b> a: <i>'${resultado.vNombreEtapa.substring(0, 7)}...'</i>`,
                                                vendedor,
                                                objToActionString
                                            );
                                        }
                                    }
                                }
                            }}
                        >
                            {catEtapas.map((etapa, index) => (
                                <option key={index} value={etapa.idEtapa}>{etapa.vNombreEtapa}</option>
                            ))}
                        </Form.Select>
                        <Button
                            size="sm"
                            variant="link"
                            className="p-0 text-danger"
                            onClick={() => setEditarEtapa("")}
                        >
                            <FontAwesomeIcon icon="times" />
                        </Button>
                    </div>
                ) : (
                    <div className="d-flex flex-column align-items-end gap-2">
                        <OverlayTrigger
                            placement="left"
                            overlay={<Tooltip>Doble clic para editar</Tooltip>}
                        >
                            <span
                                style={{ cursor: 'pointer' }}
                                onClick={(event) => {
                                    if (event.detail === 2) {
                                        setEditarEtapa(idLead);
                                    }
                                }}
                            >
                                <Badge
                                    bg={
                                        idEtapa == 1 ? "secondary" :
                                            idEtapa == 2 ? "primary" :
                                                idEtapa == 3 ? "warning" :
                                                    idEtapa == 4 ? "success" :
                                                        idEtapa == 5 ? "danger" :
                                                            idEtapa == 6 ? "warning" :
                                                                idEtapa == 7 ? "success" : "success"
                                    }
                                    className="px-3 py-2 fw-semibold text-uppercase"
                                    style={{
                                        fontSize: '0.7rem',
                                        letterSpacing: '0.5px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                                        transition: 'all 0.2s ease',
                                        border: 'none'
                                    }}
                                >
                                    {vNombreEtapa}
                                </Badge>
                            </span>
                        </OverlayTrigger>
                        
                        <div className="d-flex align-items-center gap-2 mt-1">
                            {idSource != 0 && sourceInfo.icon ? (
                                <>
                                    <img
                                        src={`/img/leads/${sourceInfo.icon}`}
                                        width={24}
                                        height={24}
                                        alt={sourceInfo.name}
                                        title={sourceInfo.name}
                                    />
                                    <Badge
                                        bg="light"
                                        text="dark"
                                        className="fs--2"
                                        style={{
                                            borderLeft: `3px solid ${sourceInfo.color}`,
                                            borderRadius: '4px'
                                        }}
                                    >
                                        {sourceInfo.name}
                                    </Badge>
                                </>
                            ) : (
                                <Badge
                                    bg="light"
                                    text="dark"
                                    className="fs--2"
                                    style={{
                                        borderLeft: '3px solid #6C757D',
                                        borderRadius: '4px'
                                    }}
                                >
                                    Sin Asignar
                                </Badge>
                            )}
                        </div>
                    </div>
                );
            }
        }
    ];

    // Columnas para leads repetidos
    const columnsRepeatedLeads = [
        {
            accessor: 'name',
            Header: 'Nombre',
            cellProps: { className: 'white-space-nowrap pe-5 ps-2 py-2' },
            Cell: rowData => {
                const { vNombreLead, idLead } = rowData.row.original;
                return (
                    <>
                        <Row>
                            <Col className="col-12 fs--3">
                                <Link to={"#"} onClick={() => { setIdLead(idLead); setShowModal(true); }}>
                                    {"Lead " + idLead}
                                </Link>
                            </Col>
                        </Row>
                        <h6 className="mb-0">
                            <Link to={"#"} onClick={() => { setIdLead(idLead); setShowModal(true); }}>
                                <img title="Ver información" src="/img/ver20.png" alt="ver" /> {vNombreLead}
                            </Link>
                        </h6>
                    </>
                );
            }
        },
        {
            accessor: 'telefono',
            Header: 'Teléfono',
            headerProps: { className: 'pe-5 white-space-nowrap' },
            cellProps: { className: 'font-sans-serif white-space-nowrap' },
            Cell: rowData => {
                const { vTelefonoLead } = rowData.row.original;
                return (
                    <>
                        &nbsp;&nbsp;
                        {vTelefonoLead.includes('+52') && <img title="México" src="/img/bandera-mexico-48.png" width="20" alt="mx" />}
                        <img width="25" src="/img/whatsapp40.png" alt="whatsapp" />
                        <span className="fs-0">{vTelefonoLead}</span>
                    </>
                );
            }
        },
        {
            accessor: 'vNombreUsuario',
            Header: 'Vendedor',
            headerProps: { className: 'pe-5 white-space-nowrap' },
            cellProps: { className: 'font-sans-serif white-space-nowrap' },
            Cell: rowData => {
                const { vNombreUsuario, dCreatedDate, iDaysDiff } = rowData.row.original;
                return (
                    <Row>
                        <Col className="col-12 text-dark fw-bold">{vNombreUsuario}</Col>
                        <Col className="col-12 text-muted">
                            Registro: {new Date(dCreatedDate).toLocaleDateString('es-mx', {
                                weekday: 'long', year: 'numeric', month: 'short', day: 'numeric'
                            })}
                        </Col>
                        <Col className="col-12">
                            <SoftBadge
                                bg={
                                    iDaysDiff >= 0 && iDaysDiff < 3 ? "success" :
                                        iDaysDiff >= 3 && iDaysDiff < 5 ? "warning" : "danger"
                                }
                            >
                                {iDaysDiff + " días sin actualizaciones"}
                            </SoftBadge>
                        </Col>
                    </Row>
                );
            }
        },
        {
            accessor: 'etapa',
            Header: 'Etapa',
            headerProps: { className: 'text-end white-space-nowrap' },
            cellProps: { className: 'font-sans-serif fs-0 text-end' },
            Cell: rowData => {
                const { idEtapa, vNombreEtapa } = rowData.row.original;
                return (
                    <SoftBadge
                        bg={
                            idEtapa == 1 ? "secondary" :
                                idEtapa == 2 ? "primary" :
                                    idEtapa == 3 ? "warning" :
                                        idEtapa == 4 ? "success" : "danger"
                        }
                    >
                        {vNombreEtapa}
                    </SoftBadge>
                );
            }
        }
    ];

    return (
        <>
            {/* Header */}
            <ContactosHeader cargando={cargando} vendedor={vendedor} />

            {/* Eventos y Leads Liberados */}
            <Card className="mb-3 shadow-sm">
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <ProximosEventos
                            proximoEvento={proximoEvento}
                            cargando={cargando}
                            setIdLead={setIdLead}
                            setShowModal={setShowModal}
                            eventosNoTerminados={eventosNoTerminados}
                        />

                        <LeadsLiberados
                            lista3LeadsLiberados={lista3LeadsLiberados}
                            tags={tags}
                            cargando={cargando}
                            setIdLead={setIdLead}
                            setShowModal={setShowModal}
                            leadsLiberados={leadsLiberados}
                        />
                    </Row>
                </Card.Body>
            </Card>

            {/* Formulario de registro */}
            <Card className="mb-3 shadow-sm">
                <Card.Body className="p-3">
                    <FormularioRegistroLead
                        cargando={cargando}
                        onSubmit={VerificarLeadRepetido}
                    />
                </Card.Body>
            </Card>

            {/* Tabla de contactos */}
            {cargando ? (
                <Card className="shadow-sm">
                    <Card.Body className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <h5 className="mt-3 text-600">Cargando leads...</h5>
                    </Card.Body>
                </Card>
            ) : (
                <>
                    <AdvanceTableWrapper
                        columns={columns}
                        data={contactos}
                        selectionColumnWidth={52}
                        sortable
                        pagination
                        rowCount={contactos.length}
                    >
                        <Card className={`shadow-sm border-0 ${styles.shadowSm}`}>
                            <Card.Header className="bg-light border-bottom px-3 py-3">
                                <FiltrosContactos

                                    vendedor={vendedor}
                                    setVendedor={setVendedor}
                                    setCatEtapas={setCatEtapas}
                                    catEtapas={catEtapas}
                                    etapa={etapa}
                                    setEtapa={setEtapa}
                                    ordenarPor={ordenarPor}
                                    setOrdenarPor={setOrdenarPor}
                                    idSource_={idSource_}
                                    setidSource_={setidSource_}
                                    tags={tags}
                                    Filter_Tags={Filter_Tags}
                                    setFilter_Tags={setFilter_Tags}
                                    mostrarLeads={mostrarLeads}
                                    filtroEventosVencidos={filtroEventosVencidos}
                                    Filter_NumTelNameLead={Filter_NumTelNameLead}
                                    setFilter_NumTelNameLead={setFilter_NumTelNameLead}
                                    filtroEventos={filtroEventos}
                                    handleCheckedFiltroEventos={handleCheckedFiltroEventos}
                                    handleCheckedFiltroEventosVencidos={handleCheckedFiltroEventosVencidos}
                                    cargando={cargando}
                                />
                            </Card.Header>
                            <Card.Body className="p-0">
                                <div className={`table-responsive ${styles.customTable}`}>
                                    <AdvanceTable
                                        table
                                        headerClassName={`bg-white text-900 fw-semi-bold align-middle border-bottom ${styles.hoverActionsTrigger}`}
                                        rowClassName="align-middle hover-actions-trigger border-bottom"
                                        tableProps={{
                                            size: 'sm',
                                            className: 'fs--1 mb-0 table-hover',
                                            style: { borderCollapse: 'separate', borderSpacing: 0 }
                                        }}
                                    />
                                </div>
                            </Card.Body>
                            <Card.Footer className={`bg-light border-top py-3 ${styles.customCardFooter}`}>
                                <AdvanceTableFooter
                                    rowCount={contactos.length}
                                    table
                                    rowInfo
                                    rowsPerPageSelection
                                    navButtons
                                />
                            </Card.Footer>
                        </Card>
                    </AdvanceTableWrapper>
                </>
            )}

            {/* Modales */}
            <ModalSeguimientoLead
                showModal={showModal}
                setShowModal={setShowModal}
                catEtapas={catEtapas}
                contactos={contactos}
                setContactos={setContactos}
                lista3LeadsLiberados={lista3LeadsLiberados}
                setLista3LeadsLiberados={setLista3LeadsLiberados}
                vendedor={vendedor}
                listaEventos={listaEventos}
                setListaEventos={setListaEventos}
                setProximoEvento={setProximoEvento}
                proximoEvento={proximoEvento}
                listaEventosPasados={listaEventosPasados}
                setListaEventosPasados={setListaEventosPasados}
                listaEventosHoy={listaEventosHoy}
                setListaEventosHoy={setListaEventosHoy}
                listaEventosFuturos={listaEventosFuturos}
                setListaEventosFuturos={setListaEventosFuturos}
                listaLeadsLiberados={listaLeadsLiberados}
                setListaLeadsLiberados={setListaLeadsLiberados}
                mostrarLeads={mostrarLeads}
                Filter_Tags={Filter_Tags}
                filtroEventosVencidos={filtroEventosVencidos}
                setEditarEtapa={setEditarEtapa}
                idLead={idLead}
                setIdLead={setIdLead}
            // vendedores={vendedores}
            />

            {/* Modal para leads similares */}
            {showModalSimilarLeads && (
                <Modal
                    show={showModalSimilarLeads}
                    onHide={() => setshowModalSimilarLeads(false)}
                    size="lg"
                    backdrop="static"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Número con coincidencias importantes {telefonoRegistrar}</Modal.Title>
                        <FalconCloseButton onClick={() => setshowModalSimilarLeads(false)} />
                    </Modal.Header>
                    <Modal.Body>
                        {procesandoModalSimilarLeads ? (
                            <Skeleton className="col-12" height={150} />
                        ) : (
                            <AdvanceTableWrapper
                                columns={columnsRepeatedLeads}
                                data={dataRepeatedLeads}
                                selectionColumnWidth={52}
                                sortable
                                pagination
                                perPage={50}
                                rowCount={dataRepeatedLeads.length}
                            >
                                <Card>
                                    <Card.Header className="px-0">
                                        <Row className="flex-between-center gy-2 px-x1">
                                            <Col xs="ms-auto">
                                                {!cargando && <AdvanceTableSearchBox table />}
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Card.Body className="p-0">
                                        <AdvanceTable
                                            table
                                            headerClassName="bg-light text-800 align-middle"
                                            rowClassName="btn-reveal-trigger align-middle"
                                            tableProps={{    size: 'sm',
                                                className: 'fs--2 mb-0 overflow-hidden'
                                            }}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        <AdvanceTableFooter
                                            rowCount={dataRepeatedLeads.length}
                                            table
                                            rowInfo
                                            navButtons
                                            rowsPerPageSelection
                                        />
                                    </Card.Footer>
                                </Card>
                            </AdvanceTableWrapper>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        {!esExactamenteIgual && !procesandoModalSimilarLeads && (
                            <Button
                                onClick={() => {
                                    GuardarLead(telefonoRegistrar);
                                    setshowModalSimilarLeads(false);
                                }}
                                variant='primary'
                            >
                                Guardar igualmente
                            </Button>
                        )}
                        <Button
                            onClick={() => setshowModalSimilarLeads(false)}
                            variant='danger'
                            disabled={procesandoModalSimilarLeads}
                        >
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* Modal para motivo de no interesado */}
            <Modal
                show={showEtapaNoInteresadoModal}
                onHide={() => {
                    setShowEtapaNoInteresadoModal(false);
                    setMotivoNoInteresado('');
                }}
                size="md"
                centered
            >
                <Modal.Header>
                    <Modal.Title>¿Por qué no estuvo interesado el Lead?</Modal.Title>
                    <CloseButton onClick={() => {
                        setShowEtapaNoInteresadoModal(false);
                        setMotivoNoInteresado('');
                    }} />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={(event) => setMotivoNoInteresado(event.target.value)}
                            value={motivoNoInteresado}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant='danger'
                        onClick={() => {
                            setShowEtapaNoInteresadoModal(false);
                            setMotivoNoInteresado('');
                        }}
                    >
                        Cancelar
                    </Button>
                    {habilitarBtnGuardar ? (
                        <Button
                            variant='success'
                            onClick={() => etapaNoInteresado(idLead)}
                        >
                            Guardar Motivo
                        </Button>
                    ) : (
                        <Button variant="primary" disabled>
                            <Spinner as="span" animation="grow" size="sm" />
                            Procesando...
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Modal de eventos */}
            {showModalEventosNoTerminados && (
                <Modal
                    show={showModalEventosNoTerminados}
                    onHide={() => setShowModalEventosNoTerminados(false)}
                    size="xl"
                    centered
                >
                    <Background image={corner2} className="p-x1" style={{ zIndex: 0 }} />
                    <Modal.Header>
                        <Modal.Title>
                            <img src={circle} height="50" alt="eventos" /> Eventos
                        </Modal.Title>
                        <FalconCloseButton
                            style={{ zIndex: 1 }}
                            onClick={() => setShowModalEventosNoTerminados(false)}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <div className={styles.eventsScroll}>
                        {cargandoModalEventos ? (
                            <Row>
                                <Col className="col-5"><Skeleton height={60} /></Col>
                                <Col className="col-5"><Skeleton height={60} /></Col>
                            </Row>
                        ) : (
                            <Row>
                                <Col className="ms-1">
                                    <Row>
                                        {/* Eventos vencidos, hoy y futuros se pueden modularizar también */}
                                        <Col className="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                                            <h5>Vencidos</h5>
                                            {listaEventosPasados.length > 0 ? (
                                                listaEventosPasados.map((evento, index) => (
                                                    <div key={index} className={`d-flex align-items-center mb-2 ${styles.eventItem}`}>
                                                        <Card className={`m-0 p-0 flex-shrink-0 ${styles.eventDateCard}`}>
                                                            <Card.Header className={`m-0 p-0 text-center text-light fw-bold ${styles.eventDateHeader}`} style={{ backgroundColor: "#6c757d" }}>
                                                                {getMes(evento.dFechaEvento)}
                                                            </Card.Header>
                                                            <Card.Body className={`m-0 p-0 text-center border border-secondary fw-bold text-muted ${styles.eventDateBody}`}>
                                                                {new Date(evento.dFechaEvento).getDate()}
                                                            </Card.Body>
                                                        </Card>
                                                        <div className="ms-2 flex-1">
                                                            <div className="text-900">
                                                                <Link to="#" onClick={() => { setIdLead(evento.idLead); setShowModal(true); }}>
                                                                    {evento.vTituloEvento}
                                                                </Link>
                                                            </div>
                                                            {evento.vNombreLead && (
                                                                <div className="text-muted small">{evento.vNombreLead}</div>
                                                            )}
                                                            <div className="text-muted small">
                                                                <img width={14} src="/img/reloj48.png" alt="reloj" /> &nbsp;
                                                                {new Date(evento.dFechaEvento).toLocaleTimeString('es-mx', { hour12: true })}
                                                                <SoftBadge className="ms-1" bg="danger">Vencido</SoftBadge>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <Alert variant="secondary">
                                                    No hay eventos <b className="text-danger">vencidos</b>
                                                </Alert>
                                            )}
                                        </Col>

                                        <Col className="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                                            <h5>Hoy</h5>
                                            {listaEventosHoy.length > 0 ? (
                                                listaEventosHoy.map((evento, index) => (
                                                    <div key={index} className={`d-flex align-items-center mb-2 ${styles.eventItem}`}>
                                                        <Card className={`m-0 p-0 flex-shrink-0 ${styles.eventDateCard}`}>
                                                            <Card.Header className={`m-0 p-0 text-center text-light fw-bold ${styles.eventDateHeader}`} style={{ backgroundColor: "#f6c23e" }}>
                                                                {getMes(evento.dFechaEvento)}
                                                            </Card.Header>
                                                            <Card.Body className={`m-0 p-0 text-center border border-warning fw-bold text-muted ${styles.eventDateBody}`}>
                                                                {new Date(evento.dFechaEvento).getDate()}
                                                            </Card.Body>
                                                        </Card>
                                                        <div className="ms-2 flex-1">
                                                            <div className="text-900">
                                                                <Link to="#" onClick={() => { setIdLead(evento.idLead); setShowModal(true); }}>
                                                                    {evento.vTituloEvento}
                                                                </Link>
                                                            </div>
                                                            {evento.vNombreLead && (
                                                                <div className="text-muted small">{evento.vNombreLead}</div>
                                                            )}
                                                            <div className="text-muted small">
                                                                <img width={14} src="/img/reloj48.png" alt="reloj" /> &nbsp;
                                                                {new Date(evento.dFechaEvento).toLocaleTimeString('es-mx', { hour12: true })}
                                                                <SoftBadge className="ms-1" bg="warning">Hoy</SoftBadge>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <Alert variant="secondary">
                                                    No hay eventos <b className="text-danger">para hoy</b>
                                                </Alert>
                                            )}
                                        </Col>

                                        <Col className="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                                            <h5>Futuros</h5>
                                            {listaEventosFuturos.length > 0 ? (
                                                listaEventosFuturos.map((evento, index) => (
                                                    <div key={index} className={`d-flex align-items-center mb-2 ${styles.eventItem}`}>
                                                        <Card className={`m-0 p-0 flex-shrink-0 ${styles.eventDateCard}`}>
                                                            <Card.Header className={`m-0 p-0 text-center text-light fw-bold ${styles.eventDateHeader}`} style={{ backgroundColor: "#198754" }}>
                                                                {getMes(evento.dFechaEvento)}
                                                            </Card.Header>
                                                            <Card.Body className={`m-0 p-0 text-center border border-success fw-bold text-muted ${styles.eventDateBody}`}>
                                                                {new Date(evento.dFechaEvento).getDate()}
                                                            </Card.Body>
                                                        </Card>
                                                        <div className="ms-2 flex-1">
                                                            <div className="text-900">
                                                                <Link to="#" onClick={() => { setIdLead(evento.idLead); setShowModal(true); }}>
                                                                    {evento.vTituloEvento}
                                                                </Link>
                                                            </div>
                                                            {evento.vNombreLead && (
                                                                <div className="text-muted small">{evento.vNombreLead}</div>
                                                            )}
                                                            <div className="text-muted small">
                                                                <img width={14} src="/img/reloj48.png" alt="reloj" /> &nbsp;
                                                                {new Date(evento.dFechaEvento).toLocaleTimeString('es-mx', { hour12: true })}
                                                                <SoftBadge className="ms-1" bg="success">Futuro</SoftBadge>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <Alert variant="secondary">
                                                    No hay eventos <b className="text-danger">futuros</b>
                                                </Alert>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        )}
                        </div>
                    </Modal.Body>
                </Modal>
            )}

            {/* Modal de leads liberados */}
            {showModalLeadsLiberados && (
                <Modal
                    show={showModalLeadsLiberados}
                    onHide={() => setShowModalLeadsLiberados(false)}
                    size="xl"
                    centered
                >
                    <Background image={corner2} className="p-x1" style={{ zIndex: 0 }} />
                    <Modal.Header>
                        <Modal.Title>
                            <img src={circle} height="50" alt="leads" /> Leads Liberados
                        </Modal.Title>
                        <FalconCloseButton
                            style={{ zIndex: 1 }}
                            onClick={() => setShowModalLeadsLiberados(false)}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        {cargandoModalLeads ? (
                            <Row>
                                <Col className="col-5"><Skeleton height={60} /></Col>
                                <Col className="col-5"><Skeleton height={60} /></Col>
                            </Row>
                        ) : (
                            <Col className="col-12">
                                <Row className="me-1">
                                    {listaLeadsLiberados.length > 0 ? (
                                        listaLeadsLiberados.map((lead, index) => (
                                            <Col key={index} className="h-100 mt-2 fs--2 col-3">
                                                <Link to={"#"} onClick={() => {
                                                    setIdLead(lead.idLead);
                                                    setShowModal(true);
                                                }}>
                                                    <Row>
                                                        <Col className="col-12 text-900 fw-semi-bold">
                                                            <img width="25" src="/img/cliente48.png" alt="lead" />
                                                            &nbsp;{"Lead " + lead.idLead}
                                                        </Col>
                                                        <Col className="col-12 fw-medium text-600 ms-2">
                                                            {lead.vNombreLead.length > 0
                                                                ? lead.vNombreLead
                                                                : "Lead #" + lead.idLead
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Link>
                                            </Col>
                                        ))
                                    ) : (
                                        <Alert className="ms-1 col-10 fs--1" variant="secondary">
                                            No hay Leads <b className="text-danger">libres</b>
                                        </Alert>
                                    )}
                                </Row>
                            </Col>
                        )}
                    </Modal.Body>
                </Modal>
            )}

            {/* Modal cliente ganado */}
            <ModalClienteGanado
                showEtapaClienteGanadoModal={showEtapaClienteGanadoModal}
                setShowEtapaClienteGanadoModal={setShowEtapaClienteGanadoModal}
                idLead={idLead}
                vNombreEtapa={vNombreEtapa}
                contactos={contactos}
                setContactos={setContactos}
                listaJsonLeadsVinculados={listaJsonLeadsVinculados}
                setEditarEtapa={setEditarEtapa}
                GuardarComentario={registrarComentario}
                detallesLead={null}
                setvNombreEtapa={null}
                vendedor={parseInt(vendedor, 10) || 0}
                crearObjAction={crearObjAction}
                guardarNotificacion={guardarNotificacion}
            />
        </>
    );
};

export default Contacts;
